import {
  Box,
  // Tabs,
  Grid,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  DialogActions,
  TextField,
  InputBase,
} from "@mui/material";
import { useState, useEffect } from "react";
// import { StyledTab } from '../../owner-landing/mui.styles'
// import AddressAutoComplete from "../AddressAutoComplete";
// import { useAppDispatch, useAppSelector } from "../../../store/appHooks";
// import MapComponent from "../MapComponent";
import axios from "axios";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { getAddressDetails } from "utils/address.util";
import { handleSnackBar } from "slices/global";
import { ALLLOWED_ZIP_COUNTRIES } from "constants/general";
import AddressAutoComplete from "components/general/AddressAutoComplete";
import MapComponent from "components/general/MapComponent";
// import ConfirmAddress from "./confirm-address";
import { API_URL, postAPICallServer } from "utils/axios.util";
// import { googleAPIKey } from "../../../firebase/google";
// import { getAddressDetails } from "../../../utils/address.util";
// import { CustomDialog } from "../../booking-documents/mui.styles";
// import ConfirmAddress from "./ConfirmAddress";
// import { ALLLOWED_ZIP_COUNTRIES } from "../../../constants/general";
// import { handleSnackBar } from "../../../slices/global";
// const a11yProps = (index: number) => {
//   return {
//     id: `simple-tab-${index}`,
//     'aria-controls': `simple-tabpanel-${index}`,
//   }
// }

const AddressForm = ({
  createAddress,
  editData,
}: {
  createAddress: any;
  editData: any;
}) => {
  const dispatch = useAppDispatch();
  const { addressReducer } = useAppSelector((state) => state);
  const [activeTab] = useState(0);
  const [addAddressDetails, setAddAddressDetails] = useState<string>("");
  const [currentLocation, setCurrentLocation] = useState<any>({
    lat: 43.0,
    lng: -75.0,
  });
  const [confirmAddress, setConfirmaAddress] = useState(false);
  const [addressConfrimationDetails, setAddressConfirmationDetails] = useState<
    any | null
  >(null);
  const [key, setKey] = useState(0); // State to change the key prop

  useEffect(() => {
    setAddressConfirmationDetails(
      editData
        ? {
            addressLine1: editData?.address_line_1,
            addressLine2: editData?.address_line_2,
            city: editData?.city,
            state: editData?.state,
            zipcode: editData?.zipcode,
            latitude: editData?.latitude,
            longitude: editData?.longitude,
            country: editData?.country || " ",
          }
        : null
    );
  }, [editData]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude: lat, longitude: lng } }) => {
        const pos = { lat, lng };
        setCurrentLocation(pos);
      }
    );
  }, []);

  useEffect(() => {
    console.log(addAddressDetails);
    if (addAddressDetails) {
      fillAddress(addAddressDetails);
    } else {
      setAddressConfirmationDetails(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addAddressDetails]);

  const addressSelected = async (e: any) => {
    if (e?.place_id) {
      setAddAddressDetails(e?.place_id);
      // setTimeout(() => submitAddress(e?.place_id), 1000)
    } else {
      setAddAddressDetails("");
    }
  };

  const getPlaceIdFromLatLng = async () => {
    try {
      const { data }: any = await postAPICallServer(`/search/placedetails`, {
        latitude: currentLocation.lat,
        longitude: currentLocation.lng,
      });
      return data.place_id;
    } catch {
      return false;
    }
  };

  const placeDetails = async (placeId: string | undefined) => {
    if (placeId) {
      const details = await postAPICallServer(`/search/placedetails`, {
        place_id: placeId,
      });
      const { data } = details.data;
      console.log(data);
      return getAddressDetails(data);
    }
  };
  const createAddressWithMap = async () => {
    const placeId = await getPlaceIdFromLatLng();
    const details: any = await placeDetails(placeId);
    if (!details.zipcode) {
      dispatch(
        handleSnackBar({
          open: true,
          message: "Invalid address, please enter valid address.",
          severity: "error",
        })
      );
      return;
    }
    if (!ALLLOWED_ZIP_COUNTRIES.includes(details?.country)) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: `This location is out of ${ALLLOWED_ZIP_COUNTRIES.join(
            ", "
          )} `,
        })
      );
      return;
    }
    setAddressConfirmationDetails(details);
    setConfirmaAddress(true);
  };

  const createFinalAddress = () => {
    if (!addressConfrimationDetails) {
      return;
    }

    createAddress(editData, {
      ...addressConfrimationDetails,
      latitude: addressConfrimationDetails.latitude,
      longitude: addressConfrimationDetails.longitude,
    });
    setAddressConfirmationDetails(null);
    setKey((prevKey) => prevKey + 1);
  };

  const fillAddress = async (placeId?: string) => {
    if (activeTab === 1) {
      createAddressWithMap();
    } else {
      const details: any = await placeDetails(placeId);
      if (!details.zipcode) {
        dispatch(
          handleSnackBar({
            open: true,
            message: "Invalid address, please enter valid address.",
            severity: "error",
          })
        );
        return;
      }
      setAddressConfirmationDetails(details);
      // setConfirmaAddress(true)
    }
  };

  return (
    <Box sx={{ mx: "4%", my: "20px" }}>
      <Typography
        sx={{
          color: "#323232",
          fontWeight: 600,
          fontSize: "20px",
          display: {
            sm: "none",
            xs: "none",
            md: "flex",
            lg: "flex",
            xl: "flex",
          },
        }}
      >
        {editData ? `Edit Address` : `Add New`}
      </Typography>
      <Box>
        <Box sx={{ my: "20px" }}>
          <Grid container spacing={2}>
            <Grid item md={12} lg={12} sm={12} xl={12} xs={12}>
              <AddressAutoComplete
                onSelect={addressSelected}
                omitAddressFilter={false}
                key={key}
                CustomInput={(params: any) => (
                  <Box
                    sx={{
                      border: "1px solid #E2E2E2",
                      borderRadius: "10px",
                      height: "56px",
                      display: "flex",
                      gap: "15px",
                      alignItems: "center",
                      px: "20px",
                    }}
                  >
                    <img src="/assets/img/icons/search_b.svg" alt="" />
                    <InputBase
                      ref={params.InputProps.ref}
                      inputProps={{
                        ...params.inputProps,
                      }}
                      sx={{
                        input: {
                          fontFamily: "Inter",
                          fontWeight: 400,
                          fontSize: "15px",
                          lineHeight: "22px",
                          padding: "0px",
                        },
                      }}
                      placeholder="Search address..."
                      fullWidth
                    />
                  </Box>
                )}
              />
            </Grid>
            <Grid item md={6} lg={6} sm={12} xl={6} xs={12}>
              <Box
                sx={{
                  border: "1px solid #E2E2E2",
                  borderRadius: "10px",
                  height: "56px",
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                  px: "20px",
                }}
              >
                <InputBase
                  placeholder="Address (street address)"
                  fullWidth
                  sx={{ button: { display: "none" } }}
                  value={addressConfrimationDetails?.addressLine1 ?? ""}
                  inputProps={{
                    style: {
                      height: 10,
                    },
                  }}
                  onChange={({ target }) =>
                    setAddressConfirmationDetails({
                      ...addressConfrimationDetails,
                      addressLine1: target.value,
                    })
                  }
                />
              </Box>
            </Grid>
            <Grid item md={6} lg={6} sm={12} xl={6} xs={12}>
              <Box
                sx={{
                  border: "1px solid #E2E2E2",
                  borderRadius: "10px",
                  height: "56px",
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                  px: "20px",
                }}
              >
                <InputBase
                  placeholder="Apt, suite, unit, building, floor, etc"
                  fullWidth
                  sx={{ button: { display: "none" } }}
                  value={addressConfrimationDetails?.addressLine2 ?? ""}
                  inputProps={{
                    style: {
                      height: 10,
                    },
                  }}
                  onChange={({ target }) =>
                    setAddressConfirmationDetails({
                      ...addressConfrimationDetails,
                      addressLine2: target.value,
                    })
                  }
                />
              </Box>
            </Grid>
            <Grid item md={6} lg={6} sm={6} xl={6} xs={6}>
              <Box
                sx={{
                  border: "1px solid #E2E2E2",
                  borderRadius: "10px",
                  height: "56px",
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                  px: "20px",
                }}
              >
                <InputBase
                  fullWidth
                  sx={{ button: { display: "none" } }}
                  inputProps={{
                    style: {
                      height: 10,
                    },
                  }}
                  value={addressConfrimationDetails?.city ?? ""}
                  disabled
                  placeholder="City/District/Town "
                />
              </Box>
            </Grid>
            <Grid item md={6} lg={6} sm={6} xl={6} xs={6}>
              <Box
                sx={{
                  border: "1px solid #E2E2E2",
                  borderRadius: "10px",
                  height: "56px",
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                  px: "20px",
                }}
              >
                <InputBase
                  fullWidth
                  sx={{ button: { display: "none" } }}
                  inputProps={{
                    style: {
                      height: 10,
                    },
                  }}
                  value={addressConfrimationDetails?.state ?? ""}
                  disabled
                  placeholder="State"
                />
              </Box>
            </Grid>
            <Grid item md={6} lg={6} sm={12} xl={6} xs={12}>
              <Box
                sx={{
                  border: "1px solid #E2E2E2",
                  borderRadius: "10px",
                  height: "56px",
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                  px: "20px",
                }}
              >
                <InputBase
                  fullWidth
                  sx={{ button: { display: "none" } }}
                  inputProps={{
                    style: {
                      height: 10,
                    },
                  }}
                  value={addressConfrimationDetails?.zipcode ?? ""}
                  disabled
                  placeholder="Pincode"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          disabled={addressReducer.addingAddress || !addressConfrimationDetails}
          onClick={createFinalAddress}
          endIcon={
            addressReducer.addingAddress ? <CircularProgress size={15} /> : null
          }
          sx={{
            borderRadius: "10px",
            height: "56px",
            width: {
              sm: "100%",
              xs: "100%",
              md: "184px",
              lg: "184px",
              xl: "184px",
            },
          }}
        >
          Save Address
        </Button>
      </Box>
    </Box>
  );
};

export default AddressForm;
